<template>
    <v-card>
        <v-card-title>{{ applicant.name }}</v-card-title>
        <v-list-item>
            <em class="caption">uemail: {{ applicant.uemail }}</em>
        </v-list-item>
        <v-list dense>
            <v-list-item v-for="option in profile" :key="`applicant-option-${option.key}`" class="super-dense">
                <v-row class="py-0">
                    <v-col :cols="4" class="py-0 text-truncate caption">{{ option.key }}: </v-col>
                    <v-col :cols="8" class="py-0">{{ option.value }}</v-col>
                </v-row>
            </v-list-item>
        </v-list>
        <v-card-actions>
            <v-btn color="primary" @click="() => $emit('accept', applicant)">{{ $t('admin.accept') }}</v-btn>
            <v-btn @click="() => $emit('reject', applicant)">{{ $t('admin.reject') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import Vue from 'vue'

const attrKeys = [
    'uemail',
    'name',
    'role',
    'updatedAt',
    'emails',
    'firstNameEng',
    'lastNameEng',
    'title',
    'gender',
    'phoneNumber',
    'photoURL',
    'wechat',
    'github',
    'facebook',
    'birthplace',
    'birthdate',
    'residence',
    'postcode',
    'workplace',
    'workposition',
    'profArea',
    'thuMajor',
    'enrollmentTime',
    'graduationTime',
    'arriveGermanyAt',
    'leaveGermanyAt',
]

export default Vue.extend({
    name: 'ApplicantCard',
    props: {
        applicant: Object,
    },
    computed: {
        profile() {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { name, uemail, ...others } = this.applicant
            const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
            return Object.entries(others)
                .map(([key, value]) => ({
                    key,
                    value: value instanceof Date ? value.toLocaleDateString(this.$i18n.locale, options) : value,
                }))
                .sort(
                    (a, b) =>
                        attrKeys.findIndex((item) => item === a.key) - attrKeys.findIndex((item) => item === b.key)
                )
        },
    },
})
</script>

<style scoped>
.super-dense {
    min-height: 20px;
}
</style>
